import React, { useContext } from "react";
import {
  Tag,
} from "@chakra-ui/react";
import AuthContext from "../../contexts/Auth";
export function InfoBar(props) {
  const auth = useContext(AuthContext);

  return (
    <>
      {auth.data && auth.data.user.is_superuser && (
        <Tag
          size="md"
          px={4}
          py={2}
          display={{ base: "none", md: "flex" }}
          background="linear-gradient(135deg, #dc2626, #b91c1c)"
          color="white"
          borderRadius="8px"
          fontWeight="600"
          fontSize="sm"
          boxShadow="0 4px 12px -2px rgba(220, 38, 38, 0.3)"
          border="1px solid rgba(255, 255, 255, 0.1)"
          className="theme-button"
          _hover={{
            transform: "translateY(-1px)",
            boxShadow: "0 6px 16px -4px rgba(220, 38, 38, 0.4)"
          }}
          transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
        >
          ADMIN HESABI KULLANIYORSUNUZ
        </Tag>
      )}
    </>
  );
}
